import React, { useContext, useRef } from 'react'
import { useEffect, useState } from 'react'
import { Input, Select, Modal, Form, Button, Typography, Table, Popconfirm, notification, AutoComplete } from 'antd'
import { observer } from 'mobx-react-lite'
import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import { useTranslation } from 'react-i18next'
import { useStore } from '../../hooks'
import styled from 'styled-components'
import { PlusOutlined } from '@ant-design/icons'
import type { FormInstance } from 'antd/es/form'
import { debounce, size } from 'lodash'
import { formatCurrency, showMessageError } from 'src/helpers/functions'
import { getStatusOrder, DATE_TIME_FORMAT_CLIENT_short, DELIVERY_CONST, GKE_SERVICES } from 'src/helpers/constants'
import moment from 'moment'
import { Loading } from 'src/common'

const formItemLayout = {
   labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
   },
   wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
   }
}

export const ModalWrapper = styled.div`
   .ant-table::-webkit-scrollbar {
      width: 8px;
      /* width of the entire scrollbar */
   }

   // .ant-table-content::-webkit-scrollbar-track {
   //    background: orange;
   //    /* color of the tracking area */
   // }

   // .ant-table-content::-webkit-scrollbar-thumb {
   //    background-color: blue;
   //    /* color of the scroll thumb */
   //    border-radius: 20px;
   //    /* roundness of the scroll thumb */
   //    border: 3px solid orange;
   //    /* creates padding around scroll thumb */
   // }
   .editable-cell {
      position: relative;
   }

   .editable-cell-value-wrap {
      padding: 5px 12px;
      cursor: pointer;
   }

   .editable-row:hover .editable-cell-value-wrap {
      padding: 4px 11px;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
   }

   [data-theme='dark'] .editable-row:hover .editable-cell-value-wrap {
      border: 1px solid #434343;
   }
`
const AssignDVVC = observer((props: any) => {
   const { t } = useTranslation()

   const { item: data, visible, onOk, onCancel, onlyView } = props
   // eslint-disable-next-line @typescript-eslint/no-unused-vars

   const OrdersStore = useStore('OrdersStore')
   const [form] = Form.useForm()
   const [loading, setLoading] = useState(false)
   const [selectedDelivery, setSelectedDelivery] = useState<string>()
   const [deliveryOptions, setDeliveryOptions] = useState<any[]>(DELIVERY_CONST)

   useEffect(() => {
      if (visible) {
         fetchDeliveryPartners()
      }
   }, [visible])

   const fetchDeliveryPartners = async () => {
      const apiList = await OrdersStore.getDeliveryPartnerList()
      if (apiList && apiList.length > 0) {
         const apiCodes = apiList.map((item: any) => item.code)
         const staticOnly = DELIVERY_CONST.filter((item) => !apiCodes.includes(item.value))
         const merged = [
            ...apiList.map((item: any) => ({ value: item.label, label: item.label })),
            ...staticOnly.map((item) => ({ value: item.label, label: item.label }))
         ]
         setDeliveryOptions(merged)
      } else {
         setDeliveryOptions(DELIVERY_CONST.map((item) => ({ value: item.label, label: item.label })))
      }
   }

   const onFinish = async (values: any) => {
      setLoading(true)
      const deliveryValue = (values.deliveryId || '').trim()

      if (!deliveryValue) {
         notification.open({
            message: 'Thông báo',
            description: 'Vui lòng nhập đơn vị vận chuyển',
            type: 'error',
            placement: 'topRight'
         })
         setLoading(false)
         return
      }

      const found = deliveryOptions.find((item) => item.value === deliveryValue)

      const formData: any = {
         deliveryPartner: deliveryValue,
         ids: data?.map((o: any) => o.id)
      }

      if (deliveryValue === 'GKE') {
         formData.service = values.service
      }

      const result = await OrdersStore.assigneeDelivery(formData)

      if (result) {
         notification.open({
            message: 'Thông báo',
            description: `Gán cho đơn vị vận chuyển ${found?.label || deliveryValue} thành công!`,
            type: 'success',
            placement: 'topRight'
         })
         onOk()
         form.resetFields()
         setSelectedDelivery(undefined)
      }

      setLoading(false)
   }

   return (
      <Modal
         width={'60%'}
         style={{ maxWidth: '1200px' }}
         visible={visible}
         centered
         title={'Gán kho vận chuyển'}
         okText={'Gửi'}
         cancelText={t(GLOBAL_CLIENT.close)}
         onCancel={onCancel}
         onOk={form.submit}
      >
         <ModalWrapper>
            <Loading isLoading={loading}></Loading>
            <Form
               {...formItemLayout}
               form={form}
               name="AssignDVVC"
               onFinish={debounce(onFinish, 400)}
               scrollToFirstError
            >
               <div style={{ marginBottom: '10px' }}></div>
               <Form.Item labelAlign="left" name="deliveryId" label={'Chọn đơn vị vận chuyển'} required>
                  <AutoComplete
                     placeholder="Nhập hoặc chọn DVVC"
                     options={deliveryOptions.map((item) => ({
                        value: item?.value,
                        label: item?.label
                     }))}
                     filterOption={(input, option) =>
                        (option?.label as string)?.toLowerCase()?.includes(input.toLowerCase()) ||
                        (option?.value as string)?.toLowerCase()?.includes(input.toLowerCase())
                     }
                     onSelect={(val: any) => {
                        setSelectedDelivery(val)
                        form.setFieldsValue({ service: undefined })
                     }}
                     onChange={(val: any) => {
                        setSelectedDelivery(val)
                        form.setFieldsValue({ service: undefined })
                     }}
                  />
               </Form.Item>

               {selectedDelivery === 'GKE' && (
                  <Form.Item
                     labelAlign="left"
                     name="service"
                     label={'Chọn dịch vụ GKE'}
                     rules={[{ required: true, message: 'Vui lòng chọn dịch vụ GKE' }]}
                  >
                     <Select placeholder="Chọn dịch vụ GKE">
                        {GKE_SERVICES.map((service) => (
                           <Select.Option key={service?.value} value={service?.value}>
                              {service?.label}
                           </Select.Option>
                        ))}
                     </Select>
                  </Form.Item>
               )}
            </Form>
         </ModalWrapper>
      </Modal>
   )
})

export default AssignDVVC
